
<div class="maintenance-container">
  <div class="content">
    <img src="assets/mascot/Mascot_under_maintenance-grey@2x.webp" />
    <h1 class="heading-13 main-desc" style="text-align: center;" [innerHTML]="contentDesc"></h1>
  </div>
</div>
